module.exports = __webpack_public_path__ + "static/media/profileDark.09c1292e.png";